import React, { useEffect, useRef, useState } from 'react';
import './WhyusTeam.css';
import {Link} from 'react-router-dom';

const WhyusTeam = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className={`whyus-team-section${isVisible ? ' animate' : ''}`}
      id="team"
    >
      <div className="whyus-team-content container">
        <div className="whyus-team-left">
          <h5 className="whyus-team-subtitle fade-up">HOW WE FUEL <br/> <span className='blue-text'>YOUR DIGITAL TRANSFORMATION</span></h5>
          <h2 className="whyus-team-title fade-up" style={{ '--animation-delay': '0.1s' }}>
           
          </h2>
          <h4 className="whyus-team-heading fade-up" style={{ '--animation-delay': '0.2s' }}>
            PROVIDING A TEAM OF WORLD-CLASS TECHNICAL EXPERTS
          </h4>
          <p className="whyus-team-description fade-up" style={{ '--animation-delay': '0.3s' }}>
            Lattice Labs has one of the most stringent hiring processes in the industry. We cover technical capabilities as well as cultural fit to ensure you work with exceptional minds and team members. This means that less than 1% of our applicants make it through our hiring procedure.
          </p>
          <br></br>
          <p className="whyus-team-description fade-up" style={{ '--animation-delay': '0.4s' }}>
            We have been recognised as one of the best Web Development and Software Development companies in the UK and Portugal by leading sites such as Clutch and Techreviewer.
          </p>
          <button className="whyus-team-btn fade-up" style={{ '--animation-delay': '0.5s' }}>
            <Link to="/contact">
            CONTACT US
            </Link>
          </button>
        </div>
        <div className="whyus-team-right fade-up" style={{ '--animation-delay': '0.6s' }}>
          {/* Replace the src below with your image path */}
          <img src="/team1.webp" alt="Team Illustration" />
        </div>
      </div>
    </section>
  );
};

export default WhyusTeam;
